export enum JoinTableErrors {
  ENTRY_DENIED = "ENTRY_DENIED",
  EXIT_DENIED = "EXIT_DENIED",
  RESERVED_TABLE = "RESERVED_TABLE",
  TABLE_FULL = "TABLE_FULL",
  TABLE_PLAN_CAPACITY_EXCEEDED = "TABLE_PLAN_CAPACITY_EXCEEDED",
  USER_AT_TABLE = "USER_AT_TABLE",
}
